/**
 * @generated SignedSource<<b534faaaeafdc717ddce9506710fb700>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueNavigator_jiraGroupedListViewData$data = {
  readonly groups: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly startCursor: string | null | undefined;
    };
    readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigatorUI_groupResults">;
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "main_issueNavigator_IssueNavigator_jiraGroupedListViewData";
};
export type main_issueNavigator_IssueNavigator_jiraGroupedListViewData$key = {
  readonly " $data"?: main_issueNavigator_IssueNavigator_jiraGroupedListViewData$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_jiraGroupedListViewData">;
};

import IssueNavigatorJiraGroupedListViewPaginationQuery_graphql from './IssueNavigatorJiraGroupedListViewPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "groups"
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "before"
    },
    {
      "kind": "RootArgument",
      "name": "dynamicSearchKey"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetsInput"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetsScope"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "groupBy"
    },
    {
      "kind": "RootArgument",
      "name": "isPaginating"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    },
    {
      "kind": "RootArgument",
      "name": "last"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    },
    {
      "kind": "RootArgument",
      "name": "saveJQLToUserHistory"
    },
    {
      "kind": "RootArgument",
      "name": "scope"
    },
    {
      "kind": "RootArgument",
      "name": "settings"
    },
    {
      "kind": "RootArgument",
      "name": "viewConfigInput"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "bidirectional",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": {
          "count": "last",
          "cursor": "before"
        },
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": IssueNavigatorJiraGroupedListViewPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "main_issueNavigator_IssueNavigator_jiraGroupedListViewData",
  "selections": [
    {
      "alias": "groups",
      "args": [
        {
          "kind": "Variable",
          "name": "__dynamicKey",
          "variableName": "dynamicSearchKey"
        },
        {
          "kind": "Variable",
          "name": "scope",
          "variableName": "scope"
        }
      ],
      "concreteType": "JiraSpreadsheetGroupConnection",
      "kind": "LinkedField",
      "name": "__IssueNavigatorJiraGroupedListViewPagination__groups_connection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraSpreadsheetGroupEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "cursor"
            },
            {
              "concreteType": "JiraSpreadsheetGroup",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "__typename"
                }
              ]
            }
          ]
        },
        {
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "endCursor"
            },
            {
              "kind": "ScalarField",
              "name": "startCursor"
            },
            {
              "kind": "ScalarField",
              "name": "hasNextPage"
            },
            {
              "kind": "ScalarField",
              "name": "hasPreviousPage"
            }
          ]
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "projectKey",
              "variableName": "projectKey"
            },
            {
              "kind": "Variable",
              "name": "projectKeys",
              "variableName": "projectKeys"
            }
          ],
          "kind": "FragmentSpread",
          "name": "main_issueNavigator_IssueNavigatorUI_groupResults"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ],
  "type": "JiraGroupedListView"
};
})();

(node as any).hash = "a3087f737b3cfd1d99f06c65f0e1b784";

export default node;
